export default __webpack_public_path__ + "static/media/kanyeList.b99eb464.png";